/* JS BROTHERS V6.2 — ordered, independently guarded feature modules. */

/* SOURCE: jsb-interactions.js */
try{
/* JS Brothers: accessible lightweight UI motion. No analytics or third-party calls. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const supports = !!(Element.prototype.animate) && !reduce.matches;
  const findCartIcon = () => document.querySelector('#ajax-cart-icon .cart-icon') || document.querySelector('#ajax-cart-icon');

  function particles(anchor) {
    if (!supports || !anchor) return;
    const r = anchor.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const colors = ['#aeaeae', '#e2e2e2', '#ececec', '#8dcfd0'];
    const frag = document.createDocumentFragment();
    for (let i = 0; i < (navigator.deviceMemory && navigator.deviceMemory <= 2 ? 10 : 18); i++) {
      const p = document.createElement('span');
      p.className = 'jsb-spark';
      p.style.left = `${cx}px`;
      p.style.top = `${cy}px`;
      p.style.setProperty('--particle-color', colors[i % colors.length]);
      const angle = i * Math.PI * 2 / 18;
      const distance = 65 + (i % 3) * 24;
      p.style.setProperty('--dx', `${Math.cos(angle) * distance}px`);
      p.style.setProperty('--dy', `${Math.sin(angle) * distance - 25}px`);
      p.style.setProperty('--rot', `${i * 67}deg`);
      p.addEventListener('animationend', () => p.remove(), { once:true });
      frag.appendChild(p);
    }
    document.body.appendChild(frag);
  }
  function bump(el, cssClass) {
    if (!el || !supports) return;
    el.classList.remove(cssClass);
    void el.offsetWidth;
    el.classList.add(cssClass);
    el.addEventListener('animationend', () => el.classList.remove(cssClass), { once:true });
  }
  function flyToCart(button) {
    const target = findCartIcon();
    if (!button || !target || !supports) {
      bump(target,'jsb-cart-bump');
      return;
    }
    const card = button.closest('.single-product-wrap,.product-detail,.product-template,.quickview-block,.product-card');
    const img = card && card.querySelector('img:not(.hidden)');
    const source = (img && img.getBoundingClientRect().width > 5) ? img : button;
    const from = source.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;
    const side = Math.min(108, Math.max(48, from.width * .39));
    const flyer = img ? document.createElement('img') : document.createElement('span');
    if (img) { flyer.src = img.currentSrc || img.src; flyer.alt = ''; }
    else { flyer.textContent = '✦'; flyer.style.display = 'grid'; flyer.style.placeItems = 'center'; flyer.style.color = '#d6d6d6'; flyer.style.background = '#1a1713'; }
    flyer.className = 'jsb-cart-fly';
    flyer.style.left = `${from.left + from.width / 2 - side / 2}px`;
    flyer.style.top = `${from.top + from.height / 2 - side / 2}px`;
    flyer.style.width = `${side}px`;
    flyer.style.height = `${side}px`;
    document.body.appendChild(flyer);
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const rise = Math.min(-90, dy * .3 - 55);
    // A miniature glass shopping bag approaches the product, then escorts it into the header cart.
    const courier = document.createElement('div');
    courier.className = 'jsb-cart-courier';
    courier.setAttribute('aria-hidden', 'true');
    courier.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linejoin="round" aria-hidden="true"><path d="M11 17h26l-2 24H13z"/><path d="M17 19v-6a7 7 0 0 1 14 0v6"/><path d="M18 28l4 4 9-10"/></svg>';
    courier.style.left = `${from.left + from.width / 2 + 20}px`;
    courier.style.top = `${from.top + from.height / 2 + 18}px`;
    document.body.appendChild(courier);
    const courierDx = to.left + to.width / 2 - (from.left + from.width / 2 + 20);
    const courierDy = to.top + to.height / 2 - (from.top + from.height / 2 + 18);
    const courierAnimation = courier.animate([
      { transform: 'translate3d(40px,50px,0) scale(.32) rotate(-17deg)', opacity: 0, offset: 0 },
      { transform: 'translate3d(0,0,0) scale(1.18) rotate(7deg)', opacity: 1, offset: .24 },
      { transform: `translate3d(${courierDx*.38}px,${rise + 33}px,0) scale(1) rotate(-8deg)`, opacity: 1, offset: .55 },
      { transform: `translate3d(${courierDx}px,${courierDy}px,0) scale(.28) rotate(0deg)`, opacity: .6, offset: 1 }
    ], {duration:390,easing:'cubic-bezier(.22,.66,.25,1)',fill:'forwards'});
    courierAnimation.onfinish = () => courier.remove();
    courierAnimation.oncancel = () => courier.remove();
    const motion = flyer.animate([
      { transform:'translate3d(0,0,0) scale(1) rotate(0deg)',opacity:1,offset:0 },
      { transform:`translate3d(${dx*.37}px,${rise}px,0) scale(.92) rotate(-9deg)`,opacity:1,offset:.44 },
      { transform:`translate3d(${dx}px,${dy}px,0) scale(.12) rotate(9deg)`,opacity:.45,offset:1 }
    ],{ duration:390,easing:'cubic-bezier(.22,.66,.25,1)',fill:'forwards' });
    motion.onfinish = () => { flyer.remove(); courier.remove(); bump(target,'jsb-cart-bump'); particles(target); showCartImpact(target); };
    motion.oncancel = () => { flyer.remove(); courier.remove(); };
  }
  function showCartImpact(target) {
    if (!supports || !target) return;
    const r = target.getBoundingClientRect();
    const el = document.createElement('div');
    el.className = 'jsb-cart-impact';
    el.setAttribute('aria-hidden', 'true');
    el.style.left = `${r.left + r.width/2}px`;
    el.style.top = `${r.top + r.height/2}px`;
    el.textContent = '✦';
    document.body.appendChild(el);
    el.addEventListener('animationend', () => el.remove(), {once: true});
  }
  // Fired only by the theme's existing cart-action after Shopify responds with success.
  window.addEventListener('jsb:cart-added', e => {
    const button = e.detail && e.detail.trigger;
    if (!button) return;
    bump(button, 'jsb-click-pop');
    if (supports) flyToCart(button);
    else bump(findCartIcon(), 'jsb-cart-bump');
  });

  // V5.6: instant, localized party-popper on the actual Add to Cart click.
  // The later jsb:cart-added event still owns the successful fly-to-header animation.
  // On a failed add we never claim the item reached the cart.
  document.addEventListener('click', e => {
    const target = e.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('.jsb55-add, cart-action button[type="submit"][name="add"], .ajax-cart-btn button[type="submit"][name="add"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    bump(button, 'jsb-click-pop');
    particles(button);
    if (supports) {
      const rect=button.getBoundingClientRect();
      const pop=document.createElement('span');
      pop.className='jsb56-confetti-emoji';
      pop.textContent='🎉';
      pop.setAttribute('aria-hidden','true');
      pop.style.left=`${rect.left+rect.width/2}px`;
      pop.style.top=`${rect.top+rect.height/2}px`;
      document.body.appendChild(pop);
      pop.addEventListener('animationend',()=>pop.remove(),{once:true});
    }
  }, {capture:true});

  // Cosmetic feedback on regular CTA clicks. Never interferes with default actions.
  document.addEventListener('click', e => {
    const button = e.target.closest('.jsb-hero__primary,.jsb-hero__secondary,.filter-button,.product-short .short-title');
    if (button && supports) bump(button, 'jsb-click-pop');
    const playback = e.target.closest('[data-jsb-playback]');
    if (playback) {
      const scope = playback.closest('.jsb-hero');
      const video = scope && scope.querySelector('video');
      if (!video) return;
      if (video.paused) { video.play().catch(() => {}); playback.setAttribute('aria-label','Pause promotional video'); playback.textContent='Ⅱ'; }
      else { video.pause(); playback.setAttribute('aria-label','Play promotional video'); playback.textContent='▶'; }
    }
  });

  // Leave native animations disabled when the visitor has asked for reduced motion.
  document.querySelectorAll('.jsb-hero video').forEach(video => {
    video.muted = true;
    video.playsInline = true;
    if (reduce.matches) video.pause();
    video.addEventListener('pause', () => {
      const btn = video.closest('.jsb-hero')?.querySelector('[data-jsb-playback]');
      if (btn) { btn.textContent='▶'; btn.setAttribute('aria-label','Play promotional video'); }
    });
    video.addEventListener('play', () => {
      const btn = video.closest('.jsb-hero')?.querySelector('[data-jsb-playback]');
      if (btn) { btn.textContent='Ⅱ'; btn.setAttribute('aria-label','Pause promotional video'); }
    });
  });
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-interactions.js",jsb62Error);}

/* SOURCE: jsb-v2.js */
try{
/* JS Brothers Ice Freeze 2.0 — vanilla enhancements. Existing Shopify actions remain authoritative. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  // V4: native CSS sticky positioning; no JS spacer or fixed-header reparenting.
  // Avoids stale viewport measurements and Shopify editor layout shift.
  // Stagger only when the existing menu controller toggles its .active class.
  document.querySelectorAll('header.header .header-bottom-area .main-menu-area .main-menu>li').forEach((li, i) => {
    li.style.setProperty('--jsb-delay', Math.min(i, 12));
  });
  const menu = document.querySelector('header.header .header-bottom-area .main-menu-area');
  const menuToggle = document.querySelector('header.header .navbar-toggle');
  if (menu && menuToggle) {
    menu.id = menu.id || 'jsb-mobile-navigation';
    menuToggle.setAttribute('aria-controls', menu.id);
    const syncMenu = () => menuToggle.setAttribute('aria-expanded', String(menu.classList.contains('active')));
    new MutationObserver(syncMenu).observe(menu, { attributes: true, attributeFilter: ['class'] });
    syncMenu();
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && menu.classList.contains('active')) {
        const close = menu.querySelector('.close-box');
        if (close) close.click();
        menuToggle.focus();
      }
    });
  }
  // Native visibility animation: runs once, no polling. Preserve reduced-motion preference.
  if (!reduce.matches && 'IntersectionObserver' in window) {
    const nodes = [...document.querySelectorAll('.jsb-arrivals__copy,.jsb-arrivals__display,.jsb-pdp-intro')];
    nodes.forEach(node => node.classList.add('jsb-scroll-in'));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('jsb-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08 });
    nodes.forEach(node => observer.observe(node));
  }
  // Keep navigation transitions local, opt-in, keyboard-friendly, no dependency on View Transitions API.
  const path = window.location.pathname;
  let arrival = false;
  try {
    arrival = sessionStorage.getItem('jsb-arrival-reveal') === '1';
    if (arrival) sessionStorage.removeItem('jsb-arrival-reveal');
  } catch (_) { /* private mode */ }
  let productReveal = false;
  try { productReveal = sessionStorage.getItem('jsb-product-reveal') === '1'; if (productReveal) sessionStorage.removeItem('jsb-product-reveal'); } catch (_) { /* optional */ }
  // V6.2: no 1.2s full-screen arrival veil; render the destination immediately.
  // Product and collection links follow normal native anchor navigation.
  // No pushState, preventDefault, URL rewriting, artificial delays or theme-preview token handling.
  // Haptic visual feedback on genuine add-to-cart attempts; successful cart event emits confetti.
  document.addEventListener('click', e => {
    const button = e.target.closest('button[name="add"],.ajax-cart-btn button');
    if (!button || button.disabled || reduce.matches) return;
    button.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(.95)', offset: .44 },
      { transform: 'scale(1.02)', offset: .75 },
      { transform: 'scale(1)' }
    ], { duration: 690, easing: 'cubic-bezier(.16,1,.3,1)' });
  });
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v2.js",jsb62Error);}

/* SOURCE: jsb-v4.js */
try{
/* Ice Freeze V4: only light progressive enhancements; Shopify theme cart / filters remain authoritative. */
(() => {
  'use strict';
  const motionOK = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initFilter() {
    const drawer = document.querySelector('#main-collection-filters .filter-sidebar');
    const toggle = document.querySelector('button.filter-button');
    if (!drawer || !toggle) return;
    const close = drawer.querySelector('button.close-filter-sidebar');
    const sync = () => {
      const expanded = drawer.classList.contains('active');
      toggle.setAttribute('aria-expanded', String(expanded));
      drawer.setAttribute('aria-label', 'Collection filters');
      toggle.setAttribute('aria-controls', 'jsb-collection-filter-drawer');
      if (!expanded) toggle.removeAttribute('aria-pressed');
    };
    drawer.id = 'jsb-collection-filter-drawer';
    // Existing main.js adds/removes .active; this supports its lifecycle and the Shopify editor.
    const observer = new MutationObserver(sync);
    observer.observe(drawer, { attributes:true, attributeFilter:['class'] });
    sync();
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !drawer.classList.contains('active')) return;
      if (close) close.click();
      else drawer.classList.remove('active');
      toggle.focus();
    });
    // A non-jQuery fallback only if the standard storefront handler did not activate a drawer.
    toggle.addEventListener('click', () => {
      queueMicrotask(() => {
        if (!drawer.classList.contains('active')) {
          drawer.classList.add('active');
          document.querySelector('.mm-fullscreen-bg')?.classList.add('active');
        }
        sync();
      });
    });
    close?.addEventListener('click', () => {
      drawer.classList.remove('active');
      document.querySelector('.mm-fullscreen-bg')?.classList.remove('active');
    });
  }
  // Native skeleton color is painted immediately by CSS; no artificial loader/latency spoofing.
  function initVisualPerformance() {
    document.querySelectorAll('.slider-category2 img,.single-product-wrap .product-image img').forEach(img => {
      img.decoding = 'async';
      if (!img.hasAttribute('loading')) img.loading = 'lazy';
    });
    if (!motionOK) return;
    // Work with compositor transforms; never animate layout or expensive image blurs per frame.
    document.querySelectorAll('.slider-category2 .cat-block').forEach(card => {
      card.addEventListener('pointerenter', () => { card.style.willChange = 'transform'; }, {passive:true});
      card.addEventListener('pointerleave', () => { card.style.willChange = ''; }, {passive:true});
    });
  }
  function init() { initFilter(); initVisualPerformance(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
  document.addEventListener('shopify:section:load', () => initVisualPerformance());
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v4.js",jsb62Error);}

/* SOURCE: jsb-v5.js */
try{
/* JS BROTHERS ICE FREEZE V5 | progressive enhancement only: never intercepts native cart checkout. */
(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '[data-jsb-bag-reveal]';
  const sleep = (ms) => new Promise(resolve => window.setTimeout(resolve, ms));

  function initBag(section) {
    if (!section || section.dataset.jsbV5Ready === '1') return;
    section.dataset.jsbV5Ready = '1';
    const products = [...section.querySelectorAll('[data-jsb-bag-product]')];
    const speech = section.querySelector('[data-jsb-bag-speech]');
    const again = section.querySelector('[data-jsb-bag-again]');
    const hear = section.querySelector('[data-jsb-bag-hear]');
    if (!speech || !again) return;
    if (hear && !('speechSynthesis' in window)) hear.hidden = true;
    hear?.addEventListener('click', () => {
      if (!('speechSynthesis' in window)) return;
      window.speechSynthesis.cancel();
      const message = new SpeechSynthesisUtterance(speech.textContent || 'Hey! Please wait. See what I have for you.');
      message.lang = 'en-US';
      message.rate = .92;
      message.pitch = 1.05;
      window.speechSynthesis.speak(message); // Direct user gesture, never surprise autoplay.
    });
    let index = 0;
    let visible = false;
    let engaged = false;
    let busy = false;
    let stopped = false;
    let timer = null;
    const lines = [
      'Hey! Please wait — see what I have for you.',
      'Look at this! Fresh from our New Arrivals.',
      'One of a kind. Could this be your next favorite?',
      'Another little surprise from the JS Brothers bag!'
    ];

    function select(indexNew) {
      index = products.length ? ((indexNew % products.length) + products.length) % products.length : 0;
      products.forEach((product, i) => {
        const selected = i === index;
        product.classList.toggle('is-selected', selected);
        product.setAttribute('aria-hidden', String(!selected));
        product.tabIndex = selected ? 0 : -1;
      });
    }
    async function reveal(first = false) {
      if (busy || stopped || !visible) return;
      busy = true;
      again.disabled = true;
      window.clearTimeout(timer);
      section.classList.remove('is-revealing');
      if (!first && products.length > 1) select(index + 1);
      speech.textContent = first ? lines[0] : lines[(index % (lines.length - 1)) + 1];
      if (!reducedMotion.matches) {
        // Force a new animation cycle without changing the CSS timing across devices.
        void section.offsetWidth;
        section.classList.add('is-revealing');
        await sleep(750);
      } else {
        section.classList.add('is-ready');
        await sleep(80);
      }
      busy = false;
      again.disabled = false;
      section.classList.remove('is-revealing');
      section.classList.add('is-ready');
      // Long idle interval: doesn't cycle rapidly, doesn't run off screen or in background tabs.
      if (visible && !document.hidden && products.length > 1) timer = window.setTimeout(() => reveal(false), 11500);
    }
    function setVisible(next) {
      visible = next;
      window.clearTimeout(timer);
      if (next && !engaged) {
        engaged = true;
        reveal(true);
      } else if (next && !busy && products.length > 1) {
        timer = window.setTimeout(() => reveal(false), 11500);
      }
    }
    select(0);
    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.target === section) setVisible(entry.isIntersecting);
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.22 });
      watcher.observe(section);
      section.addEventListener('shopify:section:unload', () => { stopped = true; watcher.disconnect(); window.clearTimeout(timer); }, {once:true});
    } else setVisible(true);
    again.addEventListener('click', () => {
      if (busy || !visible) return;
      reveal(false);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) window.clearTimeout(timer);
      else if (visible && !busy && products.length > 1) timer = window.setTimeout(() => reveal(false), 11500);
    });
  }

  function initDrawers() {
    const menu = document.querySelector('header.header .header-bottom-area .main-menu-area');
    const menuTrigger = document.querySelector('header.header button.navbar-toggle');
    const closeMenu = menu?.querySelector('button.close-box');
    const filter = document.querySelector('#main-collection-filters .filter-sidebar');
    const filterTrigger = document.querySelector('button.filter-button');
    const closeFilter = filter?.querySelector('button.close-filter-sidebar');
    const backdrop = document.querySelector('.mm-fullscreen-bg');
    if (menu && menuTrigger && menu.dataset.jsbV5Accessible !== '1') {
      menu.dataset.jsbV5Accessible = '1';
      menu.id = menu.id || 'jsb-v5-navigation';
      menuTrigger.setAttribute('aria-controls', menu.id);
      menuTrigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('role', 'navigation');
      menu.setAttribute('aria-label', 'Mobile store navigation');
      menu.querySelectorAll('.main-menu>li').forEach((item,i) => item.style.setProperty('--jsb-delay', String(i)));
      const syncMenu = () => menuTrigger.setAttribute('aria-expanded', String(menu.classList.contains('active')));
      const observer = new MutationObserver(syncMenu);
      observer.observe(menu, {attributes:true, attributeFilter:['class']});
      syncMenu();
      closeMenu?.addEventListener('click', () => { menuTrigger.focus({preventScroll:true}); });
    }
    if (filter && filterTrigger && filter.dataset.jsbV5Accessible !== '1') {
      filter.dataset.jsbV5Accessible = '1';
      filter.setAttribute('role','region');
      filter.setAttribute('aria-label','Shop by size, price and other filters');
      const observe = new MutationObserver(() => filterTrigger.setAttribute('aria-expanded',String(filter.classList.contains('active'))));
      observe.observe(filter,{attributes:true,attributeFilter:['class']});
      filterTrigger.setAttribute('aria-expanded',String(filter.classList.contains('active')));
      // Existing collection-sidebar.js owns AJAX facet filtering. This handles close focus only.
      closeFilter?.addEventListener('click', () => {filterTrigger.focus({preventScroll:true});});
      filter.querySelectorAll('input.cust-checkbox').forEach(input=>{
        input.addEventListener('change',()=>{ input.closest('.cust-checkbox-label')?.classList.toggle('is-checked',input.checked); });
      });
    }
    if ((!menu && !filter) || document.body.dataset.jsbV5DrawerKeys === '1') return;
    document.body.dataset.jsbV5DrawerKeys = '1';
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if (menu?.classList.contains('active')) {closeMenu?.click();menuTrigger?.focus({preventScroll:true});}
      if (filter?.classList.contains('active')) {closeFilter?.click();filterTrigger?.focus({preventScroll:true});}
    });
    // Native main.js dismisses both through the same overlay; simply restore focus.
    backdrop?.addEventListener('click',()=>{
      if (menu?.classList.contains('active')) menuTrigger?.focus({preventScroll:true});
      if (filter?.classList.contains('active')) filterTrigger?.focus({preventScroll:true});
    });
  }
  function init(root=document) {
    root.querySelectorAll?.(selector).forEach(initBag);
    initDrawers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v5.js",jsb62Error);}

/* SOURCE: jsb-v54-route-audit.js */
try{
/* JS BROTHERS V5.4 — product-route instrumentation. No navigation interception. */
(() => {
  'use strict';
  const key = 'jsb_v54_last_product_click';
  const productRe = /(?:^|\/)products\/([^/?#]+)/i;
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !productRe.test(url.pathname)) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        title: (anchor.getAttribute('title') || anchor.textContent || anchor.closest('.single-product-wrap')?.querySelector('.jsb-product-name')?.textContent || '').trim().slice(0,120),
        href: anchor.href,
        from: location.pathname,
        theme: window.Shopify?.theme?.name || 'unknown',
        themeRole: window.Shopify?.theme?.role || 'unknown',
        recordedAt: Date.now()
      }));
    } catch (_) { /* session storage may be blocked */ }
  }, {capture: true, passive: true});
  if (!document.body.classList.contains('template-404')) return;
  const panel = document.querySelector('#jsb-route-diagnostic');
  const output = document.querySelector('#jsb-route-diagnostic-output');
  if (!panel || !output) return;
  const params = new URLSearchParams(location.search);
  const role = window.Shopify?.theme?.role || 'unknown';
  // Only auto-show in draft preview; optional debug parameter works in any theme.
  if (role !== 'unpublished' && role !== 'development' && params.get('jsb_debug') !== '1') return;
  panel.hidden = false;
  let previous;
  try { previous = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { previous=null; }
  const path = location.pathname;
  const found = path.match(productRe);
  const expected = previous?.href ? new URL(previous.href).pathname : '(not recorded)';
  const values = {
    'Clicked product': previous?.title || '(not recorded)',
    'Clicked link': previous?.href || '(not recorded)',
    '404 route': path,
    'Product path matches link': previous ? String(expected === path) : '(unknown)',
    'Active locale': window.Shopify?.locale || '(unknown)',
    'Shopify route root': window.Shopify?.routes?.root || '(unknown)',
    'Theme role': role,
    'Product JSON status': '(checking)'
  };
  const render=()=>{output.textContent=Object.entries(values).map(([k,v])=>`${k}: ${v}`).join('\n')};
  render();
  let handle = found?.[1];
  if (!handle && previous?.href) handle=new URL(previous.href).pathname.match(productRe)?.[1];
  if (!handle) { values['Product JSON status']='No /products/HANDLE path — inspect the link above';render();return; }
  const root=(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  fetch(`${root}products/${encodeURIComponent(handle)}.js`, {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'})
    .then(async res=>{
      values['Product JSON status'] = `HTTP ${res.status} — ${res.ok ? 'product data available' : 'product unavailable / blocked'}`;
      if (res.ok) { const data=await res.json().catch(()=>null); if(data?.title) values['Shopify product title']=data.title; }
      render();
    })
    .catch(e=>{values['Product JSON status']=`Fetch failed: ${e.name}`;render()});
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v54-route-audit.js",jsb62Error);}

/* SOURCE: jsb-v53-performance.js */
try{
/* JS BROTHERS V5.3: no fake progress indicators, no AJAX navigation interception. */
(() => {
  'use strict';
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const dataSaver = !!connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType || '');
  const weakDevice = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 2;
  if (dataSaver || weakDevice) document.documentElement.classList.add('jsb-lite-motion');

  function setupHero(hero) {
    if (!hero || hero.dataset.jsb53Ready) return;
    hero.dataset.jsb53Ready = '1';
    const video = hero.querySelector('.jsb-phone video');
    const iframe = hero.querySelector('iframe[data-jsb-video-src]');
    const playButton = hero.querySelector('[data-jsb-playback]');
    if (!video && !iframe) return;
    let visible = false;
    let userPaused = false;
    let manuallyStarted = false;
    let didLoadIframe = false;
    const shouldPlay = () => visible && !document.hidden && (!dataSaver || manuallyStarted) && (!media.matches || manuallyStarted) && !userPaused;
    function update() {
      if (iframe) {
        // Embedded players load only when the visitor reaches the hero, except on Save-Data.
        if (visible && !didLoadIframe && !dataSaver) {
          iframe.src = iframe.dataset.jsbVideoSrc;
          didLoadIframe = true;
        }
        return;
      }
      if (!video) return;
      if (shouldPlay()) {
        video.muted = true;
        video.playsInline = true;
        video.play().catch(() => {});
      } else if (!video.paused) video.pause();
    }
    if (playButton && video) {
      // Capture marks intentional pause/play before the existing click handler runs.
      playButton.addEventListener('click', () => {
        const wasPaused = video.paused;
        userPaused = !wasPaused;
        if (wasPaused) manuallyStarted = true;
      }, true);
    }
    if (iframe && dataSaver) {
      const loadButton = document.createElement('button');
      loadButton.type = 'button';
      loadButton.className = 'jsb-v53-embed-optin';
      loadButton.textContent = '▶ PLAY PROMO VIDEO';
      loadButton.setAttribute('aria-label', 'Load promotional video using mobile data');
      iframe.parentElement?.appendChild(loadButton);
      loadButton.addEventListener('click', () => {
        iframe.src = iframe.dataset.jsbVideoSrc;
        didLoadIframe = true;
        loadButton.remove();
      }, {once:true});
    }
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.target === hero) { visible = entry.isIntersecting; update(); }
      }, {rootMargin:'160px 0px',threshold:0.05});
      observer.observe(hero);
      hero.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    } else { visible = true; update(); }
    document.addEventListener('visibilitychange', update);
    media.addEventListener?.('change', update);

  }
  function init(root=document) { root.querySelectorAll?.('.jsb-hero').forEach(setupHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v53-performance.js",jsb62Error);}

/* SOURCE: jsb-v55-pdp-recovery.js */
try{
/* Optional draft-only recovery for product HTML 404 with public product JSON 200. */
(()=>{'use strict';if(!document.body.classList.contains('template-404'))return;
const role=window.Shopify?.theme?.role;const query=new URLSearchParams(location.search);
if(role!=='unpublished'&&role!=='development'&&query.get('jsb_debug')!=='1')return;
if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#]+$/i.test(location.pathname)||query.get('view')==='jsb-elite')return;
const handle=location.pathname.split('/').pop();if(!handle)return;
const url=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle)+'.js';
fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)return;const target=new URL(location.href);target.searchParams.set('view','jsb-elite');target.searchParams.set('jsb_recovery','1');location.replace(target.href)}).catch(()=>{});
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v55-pdp-recovery.js",jsb62Error);}

/* SOURCE: jsb-v57-size-check.js */
try{
/* JS BROTHERS V5.7 — Size verification confirmation before native Shopify cart submit.
   No external audio, cookies, fonts, networking, or analytics. */
(() => {
  'use strict';
  if (window.__jsb57SizeVerification) return;
  window.__jsb57SizeVerification = true;

  const LABELS = {
    heading: 'SIZE VERIFICATION ALERT',
    subheading: 'Please double-check your size before ordering.',
    policy: 'Please verify your selected size and measurements before ordering. For returns caused by size issues, exchanges are available, but refunds are not offered. Please confirm your size.',
    confirm: 'YES, I AM SURE ABOUT MY SIZE',
    success: 'THANK YOU! SIZE CONFIRMED',
    successText: 'Adding your selected item to the cart…'
  };
  let dialog = null;
  let current = null;
  let sequence = 0;
  let closingTimer = 0;
  let previousFocus = null;
  const reducedMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Audio starts from the direct submit gesture; if autoplay/audio is blocked we continue silently.
  function alertTune(kind) {
    try {
      const Context = window.AudioContext || window.webkitAudioContext;
      if (!Context) return;
      const ctx = new Context();
      if (ctx.state === 'suspended') ctx.resume().catch(() => {});
      const now = ctx.currentTime + 0.015;
      const notes = kind === 'success' ? [660, 880] : [860, 610, 430];
      const len = kind === 'success' ? .105 : .14;
      notes.forEach((freq, i) => {
        const start = now + i * (len + .055);
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = 'sine';
        o.frequency.setValueAtTime(freq, start);
        g.gain.setValueAtTime(.0001, start);
        g.gain.exponentialRampToValueAtTime(kind === 'success' ? .045 : .075, start + .012);
        g.gain.exponentialRampToValueAtTime(.0001, start + len);
        o.connect(g); g.connect(ctx.destination);
        o.start(start); o.stop(start + len + .015);
      });
      window.setTimeout(() => ctx.close().catch(() => {}), 950);
    } catch (_) { /* sound is optional */ }
  }

  function alertVibration(kind) {
    // navigator.vibrate is mainly supported on Android Chromium browsers, not iOS Safari.
    try {
      if (!navigator.vibrate) return;
      navigator.vibrate(kind === 'success' ? [80, 45, 95] : [180, 80, 220, 90, 260]);
    } catch (_) { /* browser/device may deny it */ }
  }

  function createDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'jsb57-size-dialog';
    dialog.setAttribute('role', 'alertdialog');
    dialog.setAttribute('aria-labelledby', 'jsb57-size-title');
    dialog.setAttribute('aria-describedby', 'jsb57-size-description');
    dialog.innerHTML = `
      <div class="jsb57-size-panel" data-jsb57-panel>
        <div class="jsb57-alert-ornament" aria-hidden="true">!</div>
        <p class="jsb57-eyebrow">JS BROTHERS · IMPORTANT ORDER CHECK</p>
        <h2 id="jsb57-size-title">${LABELS.heading}</h2>
        <p class="jsb57-subheading">${LABELS.subheading}</p>
        <div class="jsb57-size-message" id="jsb57-size-description"></div>
        <p class="jsb57-variant" data-jsb57-variant hidden></p>
        <p class="jsb57-product" data-jsb57-product></p>
        <div class="jsb57-actions">
          <button type="button" class="jsb57-confirm" data-jsb57-confirm>${LABELS.confirm}</button>
          <button type="button" class="jsb57-cancel" data-jsb57-cancel>CHECK SIZE AGAIN</button>
        </div>
        <div class="jsb57-success" role="status" aria-live="polite" hidden>
          <span class="jsb57-success-symbol" aria-hidden="true">✓</span>
          <h2>${LABELS.success}</h2>
          <p>${LABELS.successText}</p>
        </div>
      </div>`;
    document.body.appendChild(dialog);
    dialog.querySelector('[data-jsb57-confirm]').addEventListener('click', accept);
    dialog.querySelector('[data-jsb57-cancel]').addEventListener('click', cancel);
    dialog.addEventListener('cancel', event => {
      if (current?.confirmed) event.preventDefault();
      else { event.preventDefault(); cancel(); }
    });
    dialog.addEventListener('click', e => {
      if (e.target === dialog && !current?.confirmed) cancel();
    });
    return dialog;
  }

  function shut() {
    clearTimeout(closingTimer);
    if (dialog?.open) dialog.close();
    dialog?.classList.remove('is-confirmed');
    current = null;
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    previousFocus = null;
  }
  function cancel() {
    sequence++;
    try { navigator.vibrate?.(0); } catch (_) {}
    shut();
  }

  function accept() {
    if (!current || current.confirmed) return;
    const state = current;
    state.confirmed = true;
    alertTune('success');
    alertVibration('success');
    dialog.classList.add('is-confirmed');
    dialog.querySelector('.jsb57-success').hidden = false;
    // A green acknowledgement is visible before the original Shopify AJAX handler runs.
    closingTimer = window.setTimeout(() => {
      if (current !== state || !state.form?.isConnected) { shut(); return; }
      const { form, submitter } = state;
      shut();
      form.dataset.jsb57Confirmed = '1';
      try {
        if (form.requestSubmit) form.requestSubmit(submitter?.isConnected ? submitter : undefined);
        else if (submitter?.isConnected) submitter.click();
      } finally {
        delete form.dataset.jsb57Confirmed;
      }
    }, reducedMotion() ? 180 : 420);
  }

  function showPrompt(form, submitter) {
    if (current) return;
    const d = createDialog();
    const productRoot = form.closest('[data-jsb55-product]');
    const policy = (productRoot?.dataset.jsb57SizePolicy || LABELS.policy).trim();
    const name = productRoot?.querySelector('.jsb55-title')?.textContent?.trim()
      || form.closest('.product-card,.single-product-wrap,.product-detail,.quickview-block')?.querySelector('.jsb6-card-title,.product-title,.product-name,h3,h2')?.textContent?.trim()
      || '';
    d.querySelector('.jsb57-size-message').textContent = policy;
    const variantLine = d.querySelector('[data-jsb57-variant]');
    const variantName = productRoot ? [...productRoot.querySelectorAll('.jsb55-option-group')].map(group => {
      const title = group.querySelector('legend')?.textContent?.trim() || 'Option';
      const value = group.querySelector('input:checked')?.value || '';
      return value ? `${title}: ${value}` : '';
    }).filter(Boolean).join(' · ') : (form.closest('.jsb6-product-card')?.querySelector('.jsb-size-pill')?.textContent?.trim() || '');
    variantLine.textContent = variantName ? `YOUR SELECTION · ${variantName}` : '';
    variantLine.hidden = !variantName;
    const productLine = d.querySelector('[data-jsb57-product]');
    productLine.textContent = name ? `Item: ${name}` : '';
    productLine.hidden = !name;
    d.classList.remove('is-confirmed');
    d.querySelector('.jsb57-success').hidden = true;
    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : submitter;
    current = { form, submitter, confirmed: false };
    const id = ++sequence;
    const open = () => {
      if (id !== sequence || !current) return;
      try {
        if (typeof d.showModal === 'function') d.showModal();
        else { d.setAttribute('open', ''); d.classList.add('jsb57-fallback'); }
        d.querySelector('[data-jsb57-confirm]')?.focus({preventScroll:true});
      } catch (_) {
        // If dialogs cannot open, confirm explicitly rather than silently adding to cart.
        const ok = window.confirm(`${LABELS.heading}\n\n${policy}\n\n${LABELS.confirm}?`);
        if (ok) accept(); else cancel();
      }
    };
    // Let the immediate gold party-popper be visible first.
    if (reducedMotion()) open();
    else window.setTimeout(open, 85);
  }

  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const cartAction = form.closest('cart-action');
    if (!cartAction) return; // Shopify Buy Now / payment flows are not intercepted.
    if (form.dataset.jsb57Confirmed === '1') return;
    const submitter = event.submitter || form.querySelector('button[name="add"], button[type="submit"]');
    if (!submitter || (!submitter.matches('[name="add"], .jsb55-add') && !form.querySelector('button[name="add"]'))) return;
    const productRoot = form.closest('[data-jsb55-product]');
    if (productRoot && productRoot.dataset.jsb57SizeCheck === 'false') return;
    if (submitter.disabled || submitter.getAttribute('aria-disabled') === 'true') return;
    // Capture-phase: prevents Shopify's cart-action form listener from submitting early.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (current) return;
    alertTune('warning');
    alertVibration('warning');
    showPrompt(form, submitter);
  }, true);
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v57-size-check.js",jsb62Error);}

/* SOURCE: jsb-v59-ice-sticky.js */
try{
/* Ice Freeze V5.9: native CSS sticky wrapper, minimal scroll-state only.
   Keep original menu/cart handlers; no fixed clones and no scroll direction hide. */
(()=>{
  'use strict';
  if(window.__jsb59StickyInit)return;
  window.__jsb59StickyInit=true;
  function setup(){
    const header=document.querySelector('header.header.header1');
    if(!header)return;
    const host=header.closest('[id^="shopify-section-"]') || header.parentElement;
    if(!host)return;
    host.classList.add('jsb59-sticky-host');
    if(host.__jsb59Bound)return;
    host.__jsb59Bound=true;
    let last=-1;
    let queued=false;
    const update=()=>{
      queued=false;
      const next=window.scrollY>24 ? 1:0;
      if(next!==last){
        last=next;
        host.classList.toggle('jsb59-scrolled',!!next);
      }
    };
    const onScroll=()=>{
      if(!queued){queued=true;requestAnimationFrame(update);}
    };
    update();
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('pageshow',update);
    const drawer=header.querySelector('.header-bottom-area .main-menu-area');
    if(drawer){
      const sync=()=>document.body.classList.toggle('jsb59-menu-open',drawer.classList.contains('active'));
      new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});
      sync();
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v59-ice-sticky.js",jsb62Error);}

/* SOURCE: jsb-v62-fast-nav.js */
try{
/* JS BROTHERS V6.2 — native navigation, no forced cinematic wait.
 * There is no preventDefault, delayed navigation, AJAX page swapping or loading curtain.
 * Prefetch only on deliberate desktop hover and a small per-page budget. */
(()=>{
  'use strict';
  if(window.__jsb62FastNav)return;
  window.__jsb62FastNav=true;
  const root=document.documentElement;
  const net=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  const lite=!!(net?.saveData || /(?:^|\b)(?:slow-2g|2g)(?:\b|$)/.test(net?.effectiveType||'') || (typeof navigator.deviceMemory==='number' && navigator.deviceMemory<=2));
  if(lite)root.classList.add('jsb62-lite');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  // Browsers that support prefetch can reuse cached PDP HTML when the request is cacheable.
  // Hover is intent, not a guarantee. Limit requests to avoid slowing current-page images.
  const supportsPrefetch=document.createElement('link').relList?.supports?.('prefetch');
  const canPrefetch=!lite && !reduced.matches && supportsPrefetch && !document.hidden && !(typeof window.sbisSupported !== "undefined" && window.sbisSupported);
  let hoverTimer=0;
  let prefetched=0;
  const warmed=new Set();
  const tryWarm=(link)=>{
    if(!canPrefetch || prefetched>=2)return;
    if(!(link instanceof HTMLAnchorElement))return;
    let url;
    try{url=new URL(link.href,location.href)}catch(_){return}
    if(url.origin!==location.origin || !/(?:^|\/)products\//.test(url.pathname) || warmed.has(url.href))return;
    warmed.add(url.href);
    prefetched++;
    const hint=document.createElement('link');
    hint.rel='prefetch';hint.as='document';hint.href=url.href;
    document.head.appendChild(hint);
  };
  document.addEventListener('pointerover', e=>{
    if(e.pointerType!=='mouse'||!canPrefetch)return;
    const link=e.target.closest?.('.jsb6-product-card a.jsb6-details-link');
    if(!link)return;
    clearTimeout(hoverTimer);
    hoverTimer=setTimeout(()=>tryWarm(link),130);
  },{passive:true});
  document.addEventListener('pointerout',e=>{
    if(e.target.closest?.('.jsb6-product-card'))clearTimeout(hoverTimer);
  },{passive:true});
  // Pause perpetual category/hero effects while far outside viewport.
  const observeMotion=()=>{
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(e=>e.target.classList.toggle('jsb62-in-view',e.isIntersecting));
    },{rootMargin:'100px 0px',threshold:0});
    document.querySelectorAll('.slider-category,.slider-category2,.jsb-hero,.jsb-bag-reveal').forEach(el=>observer.observe(el));
    root.classList.add('jsb62-visibility-ready');
    document.addEventListener('shopify:section:load',event=>{
      event.target.querySelectorAll?.('.slider-category,.slider-category2,.jsb-hero,.jsb-bag-reveal').forEach(el=>observer.observe(el));
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeMotion,{once:true});
  else observeMotion();
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v62-fast-nav.js",jsb62Error);}

/* SOURCE: jsb-v61-cart-shine.js */
try{
/* JS BROTHERS V6.1 — sync header shine to Shopify's actual cart count.
   No polling, no network calls, no modifications to cart requests. */
(() => {
  'use strict';
  const icon = document.getElementById('ajax-cart-icon');
  if (!icon) return;
  const sync = () => {
    const updatedIcon = icon.querySelector('[data-jsb-cart-quantity]');
    const raw = updatedIcon ? updatedIcon.getAttribute('data-jsb-cart-quantity') : icon.getAttribute('data-jsb-cart-quantity');
    const fallbackText = icon.querySelector('.ajax-cart-count span[aria-hidden="true"]')?.textContent?.trim();
    const amount = Number(raw ?? fallbackText ?? '0');
    if (!Number.isFinite(amount)) return;
    icon.classList.toggle('jsb61-has-items', amount > 0);
  };
  sync();
  // AJAX cart sections replace the icon's children; observe ONLY that small subtree.
  const observer = new MutationObserver(sync);
  observer.observe(icon,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-jsb-cart-quantity']});
  document.addEventListener('cart:updated',sync);
  document.addEventListener('cart:refresh',sync);
  document.addEventListener('shopify:section:load',sync);
})();

}catch(jsb62Error){console.warn("JSB optional feature skipped", "jsb-v61-cart-shine.js",jsb62Error);}


/* JS BROTHERS V8.1 — numeric fit measurement sourced ONLY from product descriptions.
 * No inference from variants (XL, L, XXL), titles, or labels.
 * Runs again for Shopify AJAX-filter replacements and infinite scroll products.
 */
(()=>{
  'use strict';
  const selector='[data-jsb81-measure-pill]:not([data-jsb81-processed])';
  // Usual merchant text: "Size L Chest 44/46 Length 27.5" or "Waist: 38/40".
  // Preserve stated measurements verbatim; do not convert pit-to-pit or infer a size.
  const matcher=/\b(chest|waist|waistline)\b\s*(?::|[-–—])?\s*(?:(?:size|measurement|measurements)\s*(?::|[-–—])?\s*)?((?:1[6-9]|[2-6]\d|7[0-2])(?:\.\d+)?)(?:\s*(\/|[-–]|to)\s*((?:1[6-9]|[2-6]\d|7[0-2])(?:\.\d+)?))?/gi;
  const normalize=text=>String(text||'')
    .replace(/\u00a0/g,' ')
    .replace(/&nbsp;|&#160;/gi,' ')
    .replace(/[“”]/g,'"')
    .replace(/[\t\r\n]+/g,' ')
    .replace(/\s+/g,' ')
    .trim();
  function parse(description,preferred){
    const text=normalize(description);
    const matches=[];
    matcher.lastIndex=0;
    let m;
    while((m=matcher.exec(text))!==null){
      const label=m[1].toLowerCase().startsWith('waist')?'WAIST':'CHEST';
      const value=m[2]+(m[3]&&m[4]?(m[3].toLowerCase()==='to'?'-':m[3])+m[4]:'');
      matches.push({label,value,position:m.index});
    }
    const preferredLabel=String(preferred||'').trim().toUpperCase();
    const scoped=(preferredLabel==='CHEST'||preferredLabel==='WAIST')
      ? matches.filter(m=>m.label===preferredLabel) : matches;
    // Descriptions sometimes contain measurements for multiple sizes. Without a
    // confirmed variant-specific measurement, do not misleadingly pick the first.
    if(new Set(scoped.map(m=>m.label+':'+m.value)).size>1)return null;
    return scoped[0]||null;
  }
  function hydrate(root=document){
    const nodes=root.querySelectorAll?.(selector)||[];
    for(const badge of nodes){
      badge.dataset.jsb81Processed='1';
      const found=parse(badge.getAttribute('data-jsb81-source'),badge.getAttribute('data-jsb81-preferred'));
      if(!found){
        if(badge.classList.contains('jsb86-pdp-measure')){
          const empty=badge.parentElement?.querySelector('[data-jsb86-fit-empty]');
          if(empty)empty.hidden=false;
        }
        continue;
      }
      const label=badge.querySelector('[data-jsb81-measure-name]');
      const value=badge.querySelector('[data-jsb81-measure-value]');
      if(!label||!value)continue;
      label.textContent=found.label;
      value.textContent=found.value;
      badge.title=`${found.label}: ${found.value} — from product description`;
      badge.hidden=false;
      if(badge.classList.contains('jsb86-pdp-measure')) badge.closest('[data-jsb55-product]')?.dispatchEvent(new CustomEvent('jsb:fit:ready'));
    }
  }
  let scheduled=false;
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;hydrate();});
  }
  function init(){
    hydrate();
    // Shopify AJAX filters can replace the entire grid container. Observe a
    // stable ancestor, but ignore changes unrelated to new measurement nodes.
    const observer=new MutationObserver(changes=>{
      if(changes.some(change=>Array.from(change.addedNodes).some(n=>
        n.nodeType===1 && (n.matches?.('[data-jsb81-measure-pill]') || n.querySelector?.('[data-jsb81-measure-pill]'))
      )))schedule();
    });
    observer.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('jsb:products:appended',schedule);
    document.addEventListener('shopify:section:load',schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
